export interface ChargeShare {
  /** How many payment records the one Stripe charge covers (one per city). */
  count: number;
  totalCents: number;
  currency: string;
  /** The other records on the same charge, so a row can say who else was paid. */
  others: { id: string; host: string | null; city: string | null }[];
}

interface ShareInput {
  id: string;
  stripe_payment_intent_id: string | null;
  amount_cents: number;
  currency: string;
  host_name: string | null;
  city: string | null;
}

/** For every payment that shares its Stripe charge with others (a trip with several cities), what it shares. */
export function chargeShares(rows: ShareInput[]): Map<string, ChargeShare> {
  const byCharge = new Map<string, ShareInput[]>();
  for (const r of rows) {
    if (!r.stripe_payment_intent_id) continue;
    byCharge.set(r.stripe_payment_intent_id, [...(byCharge.get(r.stripe_payment_intent_id) ?? []), r]);
  }
  const out = new Map<string, ChargeShare>();
  for (const group of byCharge.values()) {
    if (group.length < 2) continue;
    const totalCents = group.reduce((n, r) => n + r.amount_cents, 0);
    for (const r of group) {
      out.set(r.id, {
        count: group.length,
        totalCents,
        currency: r.currency,
        others: group.filter((o) => o.id !== r.id).map((o) => ({ id: o.id, host: o.host_name, city: o.city })),
      });
    }
  }
  return out;
}
